const getters = {
    getInventoryMode: state => {
        return state.inventoryMode
    },

    getInventoryDrawerState: state => {
        return state.inventoryDrawer
    },

    getInventoryTotal: state => {
        return state.inventoryTotal
    },

    getInventoryPersonal: state => {
        return state.inventoryPersonal
    },

    getInventoryAvailable: state => {
        return state.inventoryAvailable
    }
}

export default getters
